import { useQuery } from '@tanstack/react-query';
import apiClient from '@/api/client';

interface OverrideStatusResponse {
  hasActiveOverride: boolean;
  userModule?: {
    id: number;
    userId: number;
    moduleId: number;
    status: string;
    startedAt: string;
    progressCheckpoint: number;
    completedAt: string | null;
    userData: string | null;
    module: {
      id: number;
      name: string;
      screenType: string;
      // Additional fields can be added as needed
    };
    isAdminOverride: boolean;
    overrideInfo: {
      createdAt: string;
      createdBy: string;
    };
  };
}

export function useOverrideStatus() {
  return useQuery<OverrideStatusResponse>({
    queryKey: ['override-status'],
    queryFn: async () => {
      const { data } = await apiClient.get('/api/module/override-status');
      return data;
    },
    staleTime: 30000, // Consider fresh for 30 seconds
    gcTime: 5 * 60 * 1000, // Keep in cache for 5 minutes
  });
}

// Helper to check if current module is an override from the module response
export function isModuleOverride(userModule: { isAdminOverride?: boolean } | null | undefined): boolean {
  return userModule?.isAdminOverride === true;
}

// Helper to extract override info from module response
export function getOverrideInfo(userModule: { 
  isAdminOverride?: boolean;
  module?: { name?: string };
  overrideInfo?: { createdAt: string; createdBy: string };
} | null | undefined) {
  if (!isModuleOverride(userModule)) return null;
  
  return {
    moduleName: userModule.module?.name || 'Unknown Module',
    overrideInfo: userModule.overrideInfo || {
      createdAt: new Date().toISOString(),
      createdBy: 'Unknown Admin'
    }
  };
}